const data = {
  "miniProductPage": {
    "errorMessage": "Oeps, er ging iets fout.",
    "youtubeVideoOf": "Youtube-video van {{productName}}",
    "deliveredTomorrow": "Morgen bezorgd",
    "temporarilySoldOut": "Tijdelijk uitverkocht",
    "shortSpecifications": "Korte specificaties",
    "prosAndCons": "Plus- en minpunten",
    "description": "Omschrijving",
    "reviews": "Reviews",
    "showMoreSpecs": "Toon meer specificaties",
    "showLessSpecs": "Toon minder specificaties",
    "accordingToSpecialist": "Volgens onze {{productType}} specialist",
    "addToCartLabel": "In mijn winkelwagen",
    "promotionalLabelForProduct": "Promotie label voor {{productName}}.",
    "includedByDefault": {
      "default": "Standaard meegeleverd",
      "nl_nl": "Altijd meegeleverd",
      "be_en": "Dit krijg je erbij",
      "be_fr": "In de doos"
    },
    "formerPrice": {
      "prefix": "Adviesprijs"
    }
  }
};

export default data;